import { Box, Button, Grid, Typography } from "@mui/material";
import { ContentFlag } from "~/components/content-flag";
import { OpenInNew as OpenInNewIcon } from "@mui/icons-material";
import { IntegrationType } from "~/operations";
import { IntegrationDynamicIcon } from "../components/IntegrationDynamicIcon";
import { IntegrationAddHeaderData, OtherIntegrations } from "./types";
import { getIntegrationAddHeaderData } from "./utils";

interface IntegrationAddHeaderProps {
  type: IntegrationType | OtherIntegrations;
}

export function IntegrationAddHeader({ type }: IntegrationAddHeaderProps) {
  const headerData: IntegrationAddHeaderData =
    getIntegrationAddHeaderData(type);

  return (
    <Box>
      <Grid
        container
        sx={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Grid
          sx={{
            display: "flex",
            alignItems: "flex-start",
            mb: {
              xs: 2,
            },
          }}
          size={{
            xs: 12,
            sm: 8,
          }}
        >
          <Box
            sx={{
              display: "flex",
              placeContent: "center",
            }}
          >
            <IntegrationDynamicIcon {...{ type, sx: { fontSize: 48 } }} />
          </Box>
          <Box ml={3}>
            <Typography
              variant="h4"
              fontWeight={700}
              lineHeight="34px" //swap to theme
              sx={{ textTransform: "uppercase" }}
            >
              {headerData.title}
            </Typography>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ mt: -2, textTransform: "uppercase" }}
            >
              {headerData.tagline}
            </Typography>
          </Box>
        </Grid>
        <Grid
          sx={{
            textAlign: { xs: "left", sm: "right" },
          }}
          size={{
            xs: 12,
            sm: 3,
          }}
        >
          <Button
            href={headerData.docsLink}
            target="_blank"
            variant="outlined"
            color="secondary"
            endIcon={<OpenInNewIcon />}
            sx={{
              py: 0.5,
              px: 1,
            }}
          >
            Documentation
          </Button>
        </Grid>
      </Grid>
      <Box sx={{ mb: 5, mt: { xs: 2, sm: 0 } }} mb={5}>
        {headerData.flags.map((flag) => (
          <ContentFlag
            flag={flag.title}
            key={flag.id}
            layout={{ mr: 2, mb: { xs: 1, sm: 0 } }}
          />
        ))}
      </Box>
    </Box>
  );
}
